import {
    GET_MODULES,
    GET_MODULES_SUCCESS,
    GET_MODULES_FAILURE,
    CREATE_MODULES,
    CREATE_MODULES_SUCCESS,
    CREATE_MODULES_FAILURE,
    SHOW_MODULES,
    SHOW_MODULES_SUCCESS,
    SHOW_MODULES_FAILURE,
    UPDATE_MODULES,
    UPDATE_MODULES_SUCCESS,
    UPDATE_MODULES_FAILURE
  } from "../types";
  
  export const getModules = (payload) => ({
    type: GET_MODULES,
    payload,
  });
  export const getModulesSuccess = (payload) => ({
    type: GET_MODULES_SUCCESS,
    payload,
  });
  export const getModulesFailure = (payload) => ({
    type: GET_MODULES_FAILURE,
    payload,
  });
  
  export const createModules = (payload) => ({
    type: CREATE_MODULES,
    payload,
  });
  export const createModulesSuccess = (payload) => ({
    type: CREATE_MODULES_SUCCESS,
    payload,
  });
  export const createModulesFailure = (payload) => ({
    type: CREATE_MODULES_FAILURE,
    payload,
  });
  
  export const showModules = (payload) => ({
    type: SHOW_MODULES,
    payload,
  });
  export const showModulesSuccess = (payload) => ({
    type: SHOW_MODULES_SUCCESS,
    payload,
  });
  export const showModulesFailure = (payload) => ({
    type: SHOW_MODULES_FAILURE,
    payload,
  });
  
  export const updateModules = (payload) => ({
    type: UPDATE_MODULES,
    payload,
  });
  export const updateModulesSuccess = (payload) => ({
    type: UPDATE_MODULES_SUCCESS,
    payload,
  });
  export const updateModulesFailure = (payload) => ({
    type: UPDATE_MODULES_FAILURE,
    payload,
  });
  
  
  